import { cn } from "@/lib/utils";

import { MarketingLink } from "./MarketingButton";
import { marketingButtonClass } from "./marketingButtonClass";
import { MARKETING_PRODUCTS } from "./products";

const SALES = [
  { label: "Super Single · Midnight Drive", amount: "+$12" },
  { label: "Album · Better Days", amount: "+$20" },
  { label: "Single · Electric Heart", amount: "+$5" },
];

export function AppWindow({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "relative z-[1] w-full overflow-hidden rounded-[24px] border border-white/[0.68] bg-white text-marketing-ink shadow-[0_28px_90px_rgba(0,0,0,0.42)]",
        className,
      )}
    >
      <div className="flex h-12 items-center gap-[7px] border-b border-marketing-line bg-[#F8F9FD] px-[17px]">
        {[0, 1, 2].map((i) => (
          <span key={i} className="size-[9px] rounded-full bg-[#D6DBEA]" />
        ))}
        <strong className="ml-2 font-open-sans text-[13px]">Lutely</strong>
      </div>
      <div className="min-h-[340px] p-[22px]">{children}</div>
    </div>
  );
}

function SalesMock() {
  return (
    <AppWindow className="rotate-1 max-[680px]:rotate-0">
      <span className="font-open-sans text-[12px] font-extrabold uppercase tracking-[0.09em] text-[#788096]">
        Sales today
      </span>
      <div className="mt-[18px] font-figtree text-[54px] font-black leading-none tracking-[-0.04em] text-blue-600">
        $842.00{" "}
        <small className="font-open-sans text-[15px] font-bold leading-[1.4] tracking-normal text-marketing-muted">
          available earnings
        </small>
      </div>
      <div className="mt-[15px] grid gap-[10px]">
        {SALES.map((sale) => (
          <div
            key={sale.label}
            className="grid grid-cols-[34px_1fr_auto] items-center gap-3 rounded-[12px] border border-marketing-line p-3"
          >
            <span className="grid size-[38px] place-items-center rounded-[11px] bg-[#EEF1FF] text-[19px] text-blue-600">
              ↗
            </span>
            <strong className="font-open-sans text-[15px]">{sale.label}</strong>
            <span className="rounded-[8px] bg-[#EEF1FF] px-2 py-[5px] font-open-sans text-[11px] font-extrabold text-blue-600">
              {sale.amount}
            </span>
          </div>
        ))}
      </div>
    </AppWindow>
  );
}

export default function SellOverviewSection({
  labels = false,
}: {
  labels?: boolean;
}) {
  const proof = [
    "0% Lutely commission",
    labels ? "Daily payouts" : "Artist-controlled pricing",
    "Sales tracked in real time",
  ];
  return (
    <section className="relative overflow-hidden [background:radial-gradient(circle_at_12%_15%,rgba(255,79,154,0.28),transparent_27%),radial-gradient(circle_at_88%_82%,rgba(66,221,168,0.2),transparent_26%),#050B2D] px-[6vw] py-[110px] text-white max-[680px]:px-5 max-[680px]:py-[82px]">
      <div className="mx-auto grid w-[min(1180px,100%)] grid-cols-[0.92fr_1.08fr] items-center gap-[72px] max-[980px]:grid-cols-1">
        <div>
          <p className="mb-[18px] font-permanent-marker text-[28px] leading-[1.1] text-teal-500">
            Direct to Fans
          </p>
          <h2 className="m-0 font-figtree text-[clamp(46px,6vw,78px)] font-black uppercase leading-[0.94] tracking-[-0.055em]">
            Sell directly.
            <br />
            <span className="text-teal-500">Keep control.</span>
          </h2>
          <p className="mt-[26px] max-w-[610px] font-open-sans text-[19px] leading-[1.65] text-white/[0.73] max-[680px]:text-[17px]">
            Set your own price, pay 0% Lutely commission, and see every sale as
            it happens. No royalty pool and no waiting for stream counts. Just a
            direct purchase between artist and fan.
          </p>
          <div className="mb-8 mt-7 flex flex-wrap gap-[10px]">
            {proof.map((item) => (
              <span
                key={item}
                className="rounded-full border border-white/[0.18] bg-white/[0.08] px-[13px] py-[9px] font-open-sans text-[13px] font-extrabold"
              >
                {item}
              </span>
            ))}
          </div>
          <MarketingLink
            to={MARKETING_PRODUCTS.sell.path}
            className={marketingButtonClass("teal")}
          >
            Start selling
          </MarketingLink>
        </div>
        <div className="min-w-0">
          <SalesMock />
        </div>
      </div>
    </section>
  );
}
